import { call, put, takeLatest } from "redux-saga/effects";
import { ADD_EMAIL } from "../redux/actions/actionTypes"
import { addEmailSuccess, emailFailure } from "../redux/actions/index"

function* addEmail(action) {
  try {
    const options = {
      method: "POST",
      body: JSON.stringify(action.details),
      headers: new Headers({
        "Content-Type": "application/json"
      })
    };
    console.log("sagas")
    console.log(action.details)
    const res = yield call(fetch, "/v1/emails/addemail", options);
    if (res.status >= 200 && res.status < 300) {
      const email = yield res.json();
  
      yield put(addEmailSuccess(email));

    } else {
      throw yield res.json();
    }
  } catch (e) {
    console.log(e)
    yield put(emailFailure(e.message));
  }
}

export default function* rootEmailsSaga() {
  yield takeLatest(ADD_EMAIL, addEmail)
}